<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-row style="font-weight:bold;">
            <center>SBC资源组</center>
          </el-row>
          <div class="padding15-tb">
            <el-row style="font-weight:bold;">
              <el-input v-model="sbcName" placeholder="请输入SBC资源名" clearable @clear="getSbcGroupList(true)" @change="getSbcGroupList(true)">
                <i slot="prefix" class="el-input__icon el-icon-search" plain @click="getSbcGroupList(true)"></i>
              </el-input>
            </el-row>

            <el-row style="font-weight:bold;">
              <el-input v-model="supplierCompanyName" placeholder="请输入线路商名" clearable @clear="getSbcGroupList(true)" @change="getSbcGroupList(true)">
                <i slot="prefix" class="el-input__icon el-icon-search" plain @click="getSbcGroupList(true)"></i>
              </el-input>
            </el-row>
          </div>
          <div style="overflow-x: hidden; overflow-y:auto;height: 80%;margin-top: 20px;">
            <el-radio-group v-model="currentSbcGroupId" @change="getSbcGroupList(false)" style="height: 650px">
              <template v-for="(item) in sbcGroupList">
                <el-row :gutter="24" :key="item.sbcGroupId" style="margin-bottom: 15px;">
                  <el-col :span="24">
                    <el-radio :label="item.sbcGroupId">{{item.sbcGroupName}}</el-radio>
                  </el-col>
                </el-row>
              </template>
            </el-radio-group>
          </div>
          <div style="margin-top: 0px">
            <el-button type="success" icon="el-icon-plus" circle @click="addSbcGroupShow"></el-button>
            <el-button type="warning" icon="el-icon-edit" circle style="margin-left: 50px;" @click="editSbcGroupDetail"></el-button>
          </div>
        </el-col>
        <el-col :span="1">
          &nbsp;
        </el-col>
        <el-col :span="17">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="SBC资源" name="sbc">
              <el-table :data="message[0].list" style="width: 100%">
                <el-table-column prop="sbcName" label="单台SBC名称" min-width="180"/>
                <el-table-column label="SBC资源组名称" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.sbcIsBind">{{scope.row.sbcGroupName}}</div>
                    <div v-if="!scope.row.sbcIsBind" style="color: #909399;">--</div>
                  </template>
                </el-table-column>
                <el-table-column label="某台SBC在该组中占有的权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.sbcWeight" v-model="scope.row.sbcWeight" :min=0 :max=100 :disabled="!scope.row.sbcIsBind"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="绑定">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.sbcIsBind"
                      v-model="scope.row.sbcIsBind"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="线路商" name="sc">
              <el-table :data="message[1].list" style="width: 100%">
                <el-table-column prop="companyName" label="线路商名称" min-width="180"/>
                <el-table-column   label="SBC资源组名称" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.groupIsBind">{{scope.row.sbcGroupName}}</div>
                    <div v-if="!scope.row.groupIsBind" style="color: #909399;">--</div>
                  </template>
                </el-table-column>
                <el-table-column label="绑定">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.groupIsBind"
                      v-model="scope.row.groupIsBind"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row style="position: fixed;bottom: 20px;left: 50%;z-index: 1000;">
        <el-button type="primary" size="mini" style="margin-left: 48%; margin-top: 20px;" @click="modifyCustomerConf">提交</el-button>
      </el-row>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="请添加资源组"
      :visible.sync="customerConfigure"
      width="35%"
      center>
      <div>
        <el-form size="small" label-width="130px" center>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="资源组名称：">
                <el-input v-model="addOrUpdateSbcGroup.sbcGroupName"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerConfigure = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addSbcGroup">保存</el-button>
      </div>
    </el-dialog>

    <router-view v-if="reload"></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customerConfigure: false,
      activeTab: 'sbc',
      message: [
        {
          'label': 'SBC资源',
          'value': 'sbc',
          'list': []
        }, {
          'label': '线路商',
          'value': 'sc',
          'list': []
        }
      ],
      sbcGroupId: null,
      currentSbcGroupId: null,
      reload: false,
      sbcName: '',
      supplierCompanyName: '',
      sbcGroupList: [],
      addOrUpdateSbcGroup: {
        id: null,
        sbcGroupName: null
      }
    };
  },
  methods: {
    // 资源组列表
    getSbcGroupList(isFirstSbcGroupId) {
      const queryUrl = `/callServer/sbcGroup/sbcGroupList?sbcName=${this.sbcName}&supplierCompanyName=${this.supplierCompanyName}`;
      this.$ajax({
        method: 'GET',
        url: queryUrl
      }).then((res) => {
        this.sbcGroupList = res.data;
        if (this.sbcGroupList.length > 0) {
          // 是否获取第一条数据。只有更新不是获取第一条数据
          if (isFirstSbcGroupId) {
            this.currentSbcGroupId = this.sbcGroupList[0].sbcGroupId;
          }
          // 再展示资源组配置
          this.sbcGroupDetail(this.currentSbcGroupId);
        } else {
          // 删除后无配置公司,置空数据
          this.currentSbcGroupId = null;
          this.message[0].list = [];
          this.message[1].list = [];
        }
      });
    },
    // 资源组配置展示
    sbcGroupDetail(sbcGroupId) {
      this.sbcDetail(sbcGroupId);
      this.scDetail(sbcGroupId);
    },
    // 某个资源组下 sbc服务配置展示
    sbcDetail(sbcGroupId) {
      this.message[0].list = [];
      this.$ajax({
        method: 'GET',
        url: `/callServer/sbcGroup/sbcDetail/${sbcGroupId}`
      }).then((res) => {
        this.message[0].list = res.data;
      });
    },
    // 某个资源组下 供应商配置展示
    scDetail(sbcGroupId) {
      this.message[1].list = [];
      this.$ajax({
        method: 'GET',
        url: `/callServer/sbcGroup/scDetail/${sbcGroupId}`
      }).then((res) => {
        this.message[1].list = res.data;
      });
    },
    // 新增sbcGroup显示
    addSbcGroupShow() {
      this.addOrUpdateSbcGroup.id = null;
      this.addOrUpdateSbcGroup.sbcGroupName = null;
      this.customerConfigure = true;
    },
    editSbcGroupDetail() {
      if (this.currentSbcGroupId === null) {
        this.$confirm('未选择任何资源组, 不能修改', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.addOrUpdateSbcGroup.id = this.currentSbcGroupId;
      this.sbcGroupList.forEach((res) => {
        if (res.sbcGroupId === this.currentSbcGroupId) {
          this.addOrUpdateSbcGroup.sbcGroupName = res.sbcGroupName;
        }
      });
      this.customerConfigure = true;
    },
    // 新增sbcGroup
    addSbcGroup() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/callServer/sbcGroup/saveSbcGroup',
        data: this.addOrUpdateSbcGroup
      }).then(() => {
        this.customerConfigure = false;
        // 添加数据后,刷新页面
        this.getSbcGroupList(true);
      });
    },
    // 更新自定义配置
    modifyCustomerConf() {
      if (this.currentSbcGroupId === null) {
        this.$confirm('未选择任何资源组,不能更新资源组详情配置', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.$confirm('您确定要更新资源组详情配置吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const sbcDetailList = [];
        const scDetailList = [];
        this.message[0].list.forEach((item) => {
          if (item.sbcIsBind) {
            sbcDetailList.push(item);
          }
        });
        this.message[1].list.forEach((item) => {
          if (item.groupIsBind) {
            scDetailList.push(item);
          }
        });
        const reqBody = {
          sbcGroupId: this.currentSbcGroupId,
          sbcDetail: sbcDetailList,
          scDetail: scDetailList
        };
        this.updateDetail(reqBody);
      });
    },
    updateDetail(data) {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/callServer/sbcGroup/updateDetail',
        data
      }).then(() => {
        // 更新数据后,刷新页面
        this.getSbcGroupList(false);
      });
    }
  },
  mounted() {
    this.getSbcGroupList(true);
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/call/sbcGroup/index.vue